/**
 * CMS often strips blockquote/cite and leaves a <p> plus trailing text.
 * Normalises .ceo-quote-card markup for _ceoQuoteCard.scss.
 */
export function structureCeoQuoteCard(root) {
  if (!root) return;

  const containers = [];
  if (root.classList.contains('ceo-quote-card')) {
    containers.push(root);
  }
  root.querySelectorAll('.ceo-quote-card').forEach((el) => {
    if (!containers.includes(el)) {
      containers.push(el);
    }
  });

  containers.forEach((container) => {
    if (container.dataset.ceoQuoteStructured === 'true') {
      return;
    }

    const directParagraphs = [...container.children].filter(
      (el) => el.tagName === 'P' && !el.closest('.ceo-quote-card__logoWrap')
    );

    let quoteEl =
      container.querySelector('.ceo-quote-card__quote') ||
      directParagraphs.find((p) => !p.classList.contains('ceo-quote-card__cite')) ||
      directParagraphs[0];

    if (quoteEl && !quoteEl.classList.contains('ceo-quote-card__quote')) {
      quoteEl.classList.add('ceo-quote-card__quote');
    }

    let citeEl = container.querySelector('.ceo-quote-card__cite');

    if (!citeEl) {
      const citeParagraph = directParagraphs.find((p) => p !== quoteEl);
      if (citeParagraph) {
        citeEl = citeParagraph;
        citeEl.classList.add('ceo-quote-card__cite');
      }
    }

    if (!citeEl) {
      [...container.childNodes].forEach((node) => {
        if (citeEl) return;
        if (node.nodeType !== Node.TEXT_NODE) return;
        const text = node.textContent.trim();
        if (!text) return;

        citeEl = document.createElement('p');
        citeEl.className = 'ceo-quote-card__cite';
        citeEl.textContent = text;
        container.replaceChild(citeEl, node);
      });
    }

    container.dataset.ceoQuoteStructured = 'true';
  });
}
